import {
	EmailOutlineIcon,
	FacebookIcon,
	FacebookMessengerIcon,
	InstagramIcon,
	LineIcon,
	LinkIcon,
	NextDoorIcon,
	RedditIcon,
	ShareIcon,
	SmsIcon,
	TikTokIcon,
	TwitterIcon,
	VkIcon,
	WhatsAppIcon,
} from '@change/ds-icons';

import type { RoundShareIconButtonChannel } from './types';

export const ICON_BY_CHANNEL: Readonly<Record<RoundShareIconButtonChannel, React.ReactNode>> = {
	instagramStories: (
		<InstagramIcon
			className="flex h-full w-full items-center justify-center rounded-full bg-[linear-gradient(37deg,#FFCB1F_19.59%,#ED0118_49.19%,#BB01B0_79.95%)]"
			svgClassName="text-white"
			size="medium"
		/>
	),
	facebook: (
		<FacebookIcon
			className="flex h-full w-full items-center justify-center overflow-hidden rounded-full bg-transparent"
			svgClassName="h-10 w-10 transform scale-125 fill-[#1877F2]!"
		/>
	),
	facebookMessenger: (
		<FacebookMessengerIcon
			className="flex h-full w-full items-center justify-center rounded-full bg-[#0A93FF]"
			svgClassName="h-[21px] w-[21px] text-white"
		/>
	),
	twitter: (
		<TwitterIcon
			className="flex h-full w-full items-center justify-center rounded-full bg-[#3A293E]"
			svgClassName="text-white"
		/>
	),
	whatsapp: (
		<WhatsAppIcon
			className="flex h-full w-full items-center justify-center rounded-full bg-[#25D366]"
			svgClassName="h-6 w-6 text-white"
		/>
	),
	instagram: (
		<InstagramIcon
			className="flex h-full w-full items-center justify-center rounded-full bg-[linear-gradient(37deg,#FFCB1F_19.59%,#ED0118_49.19%,#BB01B0_79.95%)]"
			svgClassName="text-white"
			size="medium"
		/>
	),
	vk: (
		<VkIcon
			className="flex h-full w-full items-center justify-center rounded-full bg-[#0077FF]"
			svgClassName="text-white"
		/>
	),
	line: (
		<LineIcon
			className="flex h-full w-full items-center justify-center rounded-full bg-[#00B900]"
			svgClassName="text-white"
		/>
	),
	nextdoor: (
		<NextDoorIcon
			className="flex h-full w-full items-center justify-center rounded-full bg-[#8ED500]"
			svgClassName="text-white"
		/>
	),
	email: (
		<EmailOutlineIcon
			className="flex h-full w-full items-center justify-center rounded-full bg-[#EDE9F3]"
			svgClassName="text-icon-strong"
		/>
	),
	sms: (
		<SmsIcon
			className="flex h-full w-full items-center justify-center rounded-full bg-[#EDE9F3]"
			svgClassName="text-icon-strong"
		/>
	),
	copy: (
		<LinkIcon
			className="flex h-full w-full items-center justify-center rounded-full bg-[#EDE9F3]"
			svgClassName="text-icon-strong"
		/>
	),
	mobileNativeShare: (
		<ShareIcon
			className="flex h-full w-full items-center justify-center rounded-full bg-[#EDE9F3]"
			svgClassName="text-icon-strong"
		/>
	),
	reddit: (
		<RedditIcon
			className="flex h-full w-full items-center justify-center rounded-full bg-[#FF4500]"
			svgClassName="text-white"
		/>
	),
	tiktok: (
		<TikTokIcon
			className="flex h-full w-full items-center justify-center rounded-full bg-[#010101]"
			svgClassName="text-white"
		/>
	),
};
